(function (angular) {
    'use strict';

    angular.module('broadcast')

        .component('step5', {
            bindings: {
                forms: "="
            },
            controller: ["broadcastWizardService",
                function (broadcastWizardService) {

                    var ctrl = this;
                    ctrl.bws = broadcastWizardService;


                    /**
                     * 
                     */
                    ctrl.send = function () {
                        broadcastWizardService.sendBroadcast();
                    }

                    /**
                     * 
                     */
                    ctrl.schedule = function () {
                        broadcastWizardService.scheduleBroadcast();
                    }

                }],
            templateUrl: 'components/toolkit/broadcast/templates/step5.html'

        })

})(window.angular);